export enum AuthState {
  AUTHENTICATED = 'authenticated',
  NOT_AUTHENTICATED = 'not_authenticated',
  REGISTERING = 'registering',
  REGISTERED = 'registered',
}
